import { useQuery } from '@tanstack/react-query';
import { EmailTemplateRecipientsResponse } from '../../../types/EmailTemplate';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

interface UseGetEmailTemplateRecipientsParams {
  eventEmailTemplateUuid: string;
}

export const getEmailTemplateRecipients = async (params: UseGetEmailTemplateRecipientsParams): Promise<EmailTemplateRecipientsResponse> => {
  const response = await CustomAxios.get<EmailTemplateRecipientsResponse>(`event_email_templates/${params.eventEmailTemplateUuid}/recipients`);
  const { data } = response;
  return data;
};

export function useGetEmailTemplateRecipients(params: UseGetEmailTemplateRecipientsParams) {
  const query = useQuery({
    queryKey: [queryKeys.emailTemplateRecipients, params.eventEmailTemplateUuid],
    queryFn: () => getEmailTemplateRecipients(params),
    enabled: !!params.eventEmailTemplateUuid,
  });
  return query;
}
